import { useDispatch, useSelector } from 'react-redux';
import { CacheEntry, ResourceData, ResourceId } from './cache.types';
import { removeCache, setCache } from './cacheReducer';

const useCacheService = <TEntity = ResourceData>(cacheName: string) => {
  const dispatch = useDispatch();

  const cache = useSelector(
    (state: Dictionary<any>) => (state.cache && state.cache[cacheName]) as CacheEntry<TEntity> | null | undefined,
  );

  const addToCache = (id: ResourceId, entityData: TEntity) => dispatch(setCache(cacheName, id, entityData));

  const replaceCache = (id: ResourceId, entityData: TEntity) => dispatch(setCache(cacheName, id, entityData));

  const invalidateCache = () => dispatch(removeCache(cacheName));

  const getValue = (id: ResourceId): TEntity | null => {
    return cache && cache.id === id ? cache.entityData : null;
  };

  return {
    cache,
    addToCache,
    replaceCache,
    invalidateCache,
    getValue,
  };
};

export default useCacheService;
